import React from 'react';
import { footerInfo } from '../../assets/constants/footerConstants';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-top">
        <div className="container">
          <div className="row g-3 justify-content-center g-lg-0">
            {/* Contact Info Items */}
            {footerInfo.map((item, index) => (
              <div key={index} className="col-lg-4 col-sm-6 col-12">
                <div className="footer-top-item lab-item">
                  <div className="lab-inner">
                    <div className="lab-thumb">
                      <img 
                        src={item.img} 
                        alt={item.alt}
                      />
                    </div>
                    <div className="lab-content">
                      <span>{item.text}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer-bottom-content text-center">
                <p>
                  &copy; 2022{" "}
                  <a href="/">زواجك مبارك </a> جميع الحقوق محفوظة
                </p>
                <p>
                  &copy; 2022{" "}
                  <a href="https://dr-social.com/">DR SOCIAL </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;